import { Modal, UI } from 'common';
import isFunction from 'lodash/isFunction';
import React, { useContext } from 'react';

import DeleteProductModal from './DeleteProductModal.component';

const { ModalContext } = Modal;
const { WrappedSplitButton, WrappedButtonType } = UI;

const ProductDetailsHeader = ({
	headerText,
	productCount,
	onDeleteProductCallback,
	collapseEastPanel,
}) => {
	const { showModal } = useContext(ModalContext);

	const onClickDeleteProducts = () => {
		showModal({
			component: DeleteProductModal,
			data: {
				onDeleteProductCallback,
				selectCount: productCount,
			},
		});
	};

	const onClickCollapsePanel = () => {
		if (isFunction(collapseEastPanel)) collapseEastPanel();
	};

	return (
		<div className="header">
			<i className="icon product-icon" />
			<div className="title">{headerText}</div>
			<WrappedSplitButton
				icon="more-icon"
				buttonType={WrappedButtonType.Icon}
				tooltip="Click to see more options"
				tooltipOptions={{
					position: 'bottom',
				}}
				model={[
					{
						label: 'Delete',
						command: onClickDeleteProducts, // <- callback for delete products
					},
					{
						label: 'Collapse',
						command: onClickCollapsePanel, // <- callback for collapse panel
					},
				]}
			/>
		</div>
	);
};

export default ProductDetailsHeader;
